document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.tp-retailers-page');
  if (!root) return;

  const searchInput = root.querySelector('#tpRetailerSearch');
  const countText = root.querySelector('#tpRetailerCount');
  const buttons = root.querySelectorAll('.tp-retailers-region-buttons button');
  const cards = Array.from(root.querySelectorAll('.tp-retailer-card'));
  const groups = Array.from(root.querySelectorAll('.tp-region-group'));
  const noResults = root.querySelector('#tpRetailersNoResults');
  const total = cards.length;

  let activeRegion = 'all';

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function normaliseRegion(value) {
    const region = normalise(value);

    if (
      region === 'mena' ||
      region === 'middle east' ||
      region === 'middle east & north africa' ||
      region === 'middle east and north africa'
    ) {
      return 'mena';
    }

    if (region === 'apac' || region === 'asia pacific') {
      return 'apac';
    }

    if (region === 'eu' || region === 'europe') {
      return 'europe';
    }

    if (region === 'uae' || region === 'dubai' || region === 'ksa' || region === 'qatar' || region === 'bahrain') {
      return 'mena';
    }

    return region;
  }

  function updateFilters() {
    const query = normalise(searchInput ? searchInput.value : '');
    let visibleCount = 0;

    cards.forEach(function (card) {
      const cardRegion = normaliseRegion(card.dataset.region || '');
      const selectedRegion = normaliseRegion(activeRegion);

      const haystack = normalise([
        card.dataset.name,
        card.dataset.city,
        card.dataset.country,
        card.dataset.region,
        card.textContent
      ].join(' '));

      const matchesRegion = selectedRegion === 'all' || cardRegion === selectedRegion;
      const matchesQuery = !query || haystack.includes(query);
      const show = matchesRegion && matchesQuery;

      card.style.display = show ? 'flex' : 'none';

      if (show) {
        visibleCount += 1;
      }
    });

    groups.forEach(function (group) {
      const visibleCards = Array.from(group.querySelectorAll('.tp-retailer-card')).filter(function (card) {
        return card.style.display !== 'none';
      });

      const countEl = group.querySelector('[data-region-count]');

      group.style.display = visibleCards.length === 0 ? 'none' : '';

      if (countEl) {
        countEl.textContent = visibleCards.length + (visibleCards.length === 1 ? ' location' : ' locations');
      }
    });

    if (countText) {
      countText.textContent = visibleCount + ' / ' + total;
    }

    if (noResults) {
      noResults.hidden = visibleCount !== 0;
    }
  }

  if (searchInput) {
    const params = new URLSearchParams(window.location.search);
    const initialQuery = params.get('country') || params.get('q') || '';

    searchInput.value = initialQuery;

    searchInput.addEventListener('input', updateFilters);
    searchInput.addEventListener('search', updateFilters);
    searchInput.addEventListener('keyup', updateFilters);
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      activeRegion = button.dataset.region || 'all';

      buttons.forEach(function (btn) {
        btn.classList.remove('is-active');
      });

      button.classList.add('is-active');

      if (searchInput) {
        searchInput.value = '';
      }

      updateFilters();
    });
  });

  updateFilters();
});